<!--
  Ohne Kopfbalken und ohne Karten-Rahmen: welche Quelle angezeigt wird, steht in der
  Quellen-Seitenleiste und in der Ueberschrift des Trefferbereichs (EPROC-11890).
-->
<div class="mb-3">
    <div>
        <div class="col">
            <div class="row justify-content-center">
                @if (!loading()) {
                    @if (cardItems().length > 0) {
                        @if (listType() === ArticleSearchListType.GRID) {
                            <article-card-grid class="w-100">
                                @for (article of cardItems(); track article.id) {
                                    <article-card
                                        data-cy="OCI_SEARCH_RESULT"
                                        [item]="article"
                                        [showDetailsAction]="false"
                                        [basketActionDisabled]="addButtonDisabled()"
                                        (basketRequested)="onBasketRequested($event)"
                                    ></article-card>
                                }
                            </article-card-grid>
                        } @else {
                            <article-row-list class="w-100">
                                @for (article of cardItems(); track article.id) {
                                    <article-row
                                        data-cy="OCI_SEARCH_RESULT"
                                        [item]="article"
                                        [showDetailsAction]="false"
                                        [basketActionDisabled]="addButtonDisabled()"
                                        (basketRequested)="onBasketRequested($event)"
                                    ></article-row>
                                }
                            </article-row-list>
                        }
                    }
                    @if (noArticlesFound()) {
                        <div class="col-auto">
                            <div class="alert alert-info">
                                {{
                                    'Es wurden keine OCI Artikel zu dem Suchbegriff "\{\{value\}\}" gefunden'
                                        | translate: { value: query() }
                                }}
                            </div>
                        </div>
                    }
                    @if (timeout()) {
                        <div class="col-auto">
                            <div class="alert alert-info">
                                {{
                                    'Leider haben wir keine Antwort vom Lieferanten bekommen, bitte versuchen Sie es später noch einmal.'
                                        | translate
                                }}
                            </div>
                        </div>
                    }
                } @else {
                    <div class="col-auto">
                        <iim-spinner color="primary" size="medium"></iim-spinner>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
